import React, { useId } from 'react';
import { Switch } from '../../ui/switch';
import Label from '../../Form/Label';
import { useFormContext, useController } from 'react-hook-form';

export type ToggleProps = Omit<
  React.ComponentProps<typeof Switch>,
  'checked' | 'onChange' | 'onCheckedChange' | 'className'
> & {
  name?: string;
  onChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  description?: string;
  hideLabel?: boolean;
};

export const Toggle = ({
  id,
  label,
  description,
  hideLabel,
  name,
  onChange: _onChange,
  ...props
}: ToggleProps) => {
  const defaultId = useId();
  id = id ?? defaultId;

  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({
    control,
    name: name ?? '',
  });

  return (
    <>
      {label && (
        <Label htmlFor={id} description={description} hideLabel={hideLabel}>
          {label}
        </Label>
      )}
      <Switch
        id={id}
        {...props}
        checked={!!value}
        onCheckedChange={onChange}
      />
    </>
  );
};
